"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClickableStyles = exports.createVariantStyles = exports.createBaseStyles = void 0;
var styles_1 = require("../../styles");
exports.createBaseStyles = function (theme) { return ({
    card: {
        width: '100%',
        border: 0,
        borderRadius: theme.radius.popper + "px",
        padding: '1rem',
        transition: 'all .2s',
    },
    cardDisabled: {
        cursor: 'not-allowed',
        '& *': {
            pointerEvents: 'none',
        },
    },
    innerDisabled: {
        opacity: 0.4,
    },
}); };
exports.createVariantStyles = function (theme) { return ({
    float: {
        base: {
            background: theme.pallete.surface.main,
            border: "1px solid " + theme.pallete.gray.c80,
            boxShadow: theme.shadows.outer[40],
        },
        invalid: {
            borderColor: theme.pallete.status.danger.main,
        },
        disabled: {
            borderColor: theme.pallete.gray.c80,
            background: theme.pallete.surface.main,
        },
    },
    outline: {
        base: {
            background: theme.pallete.surface.main,
            border: "1px solid " + theme.pallete.gray.c80,
            borderRadius: theme.radius.popper + "px",
        },
        invalid: {
            borderColor: theme.pallete.status.danger.main,
        },
        disabled: { borderColor: theme.pallete.gray.c80, background: theme.pallete.surface.main },
    },
    plain: {
        base: {
            background: theme.pallete.surface.main,
            borderRadius: theme.radius.popper + "px",
        },
        invalid: {
            background: theme.pallete.status.danger.c90,
        },
        disabled: { borderColor: theme.pallete.gray.c80, background: theme.pallete.surface.main },
    },
}); };
exports.createClickableStyles = function (theme) { return (__assign(__assign({}, theme.typography.variant('main')), { cursor: 'pointer', textAlign: 'initial', '&[data-variant="outline"], &[data-variant="plain"]': {
        borderColor: theme.pallete.gray.c60,
    }, ':not(:disabled):hover': {
        background: styles_1.hexToRGB(theme.pallete.gray.c50, 0.1),
        '&[data-variant="float"]': {
            boxShadow: theme.shadows.outer[160],
        },
    }, ':focus': {
        outline: 'none',
        boxShadow: styles_1.focusBoxShadow(theme),
        '&[data-variant="float"]': {
            boxShadow: theme.shadows.outer[40] + ", " + styles_1.focusBoxShadow(theme),
        },
    }, ':not(:disabled):not(:active):hover:focus': {
        '&[data-variant="float"]': {
            boxShadow: theme.shadows.outer[160] + ", " + styles_1.focusBoxShadow(theme),
        },
    }, ':not(:disabled):active': {
        boxShadow: theme.shadows.inner['10'],
        '&[data-variant="float"]': {
            // use zero box shadow to keep transition smooth
            boxShadow: "0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0), " + theme.shadows.inner['10'],
        },
    }, '&[data-selected="true"]': {
        background: theme.pallete.primary.c90,
        borderColor: theme.pallete.primary.main,
        ':not(:disabled):hover': {
            background: theme.pallete.primary.c80,
        },
        '&[data-invalid="true"]': {
            background: theme.pallete.status.danger.c90,
        },
    }, '&[data-invalid="true"]': {
        borderColor: theme.pallete.status.danger.main,
        ':not(:disabled):hover': {
            background: theme.pallete.status.danger.c80,
        },
        ':focus': {
            outline: 'none',
            boxShadow: styles_1.focusBoxShadow(theme, 'danger'),
        },
        ':not(:disabled):active': {
            boxShadow: theme.shadows.inner['10'],
        },
        ':not(:disabled):not(:active):hover:focus': {
            '&[data-variant="float"]': {
                boxShadow: theme.shadows.outer[160] + ", " + styles_1.focusBoxShadow(theme, 'danger'),
            },
        },
    }, ':disabled': {
        borderColor: theme.pallete.gray.c80,
        '&[data-selected="true"]': {
            borderColor: theme.pallete.primary.c80,
        },
        '&[data-invalid="true"]': {
            background: theme.pallete.surface.main,
            '&[data-selected="true"]': {
                borderColor: theme.pallete.status.danger.c80,
                background: theme.pallete.status.danger.c90,
            },
        },
    } })); };
//# sourceMappingURL=cardVariants.js.map